/* ════════════════════════════════════════════════════════════
   ced-diagnostico.js — Casa del Estilista · Diagnóstico Capilar
   Vanilla, sin dependencias. Namespaced en window.CED.
   - Teaser de la home: cambia la vista previa al pulsar un chip.
   - Quiz: máquina de estados de 4 pasos + pantalla de resultado.
   - Persistencia en sessionStorage ('ced_diag') + deep-link ?perfil=.
   - Handoff: evento 'ced:diag:result' + data-hooks para apps externas.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  window.CED = window.CED || {};

  var STORE_KEY = 'ced_diag';

  function readStore() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function writeStore(obj) {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) {}
  }
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  /* ──────────────────────────────────────────────
     MOTOR DE SCORING — compartido por home + quiz
     ────────────────────────────────────────────── */
  var SCORES = {
    // P1 — preocupación principal (ancla el resultado)
    'frizz':      { frizz: 10, seco: 2 },
    'seco':       { seco: 10, frizz: 2, brillo: 2 },
    'caida':      { caida: 10, seco: 2 },
    'quimico':    { quimico: 10, frizz: 2 },
    'brillo':     { brillo: 10, seco: 3 },
    // P2 — teñido / químico (tenido:12 garantiza que Q2='tenido' supera cualquier Q1 simple)
    'tenido':     { tenido: 12, brillo: 1 },
    'decolorado': { quimico: 6, tenido: 5 },
    'no': {}, 'no_seguro': {},
    // P3 — tipo de cabello
    'fino':       { caida: 4, seco: 2 },
    'normal':     {},
    'grueso':     { frizz: 3, seco: 2 },
    'mixto':      { seco: 3, frizz: 2 },
    // P4 — herramientas de calor
    'plancha':    { quimico: 6, frizz: 2 },
    'secador':    { frizz: 5, quimico: 2 },
    'ambas':      { quimico: 8, frizz: 3 },
    'ninguna':    {}
  };

  var MENTION = {
    'frizz': 'frizz y encrespamiento',
    'seco': 'sequedad',
    'caida': 'caída capilar',
    'quimico': 'daño químico',
    'brillo': 'falta de brillo',
    'tenido': 'cabello teñido',
    'decolorado': 'decoloración',
    'fino': 'cabello fino',
    'grueso': 'cabello grueso',
    'mixto': 'cabello mixto',
    'plancha': 'uso de plancha',
    'secador': 'uso de secador',
    'ambas': 'uso frecuente de calor'
  };

  function calcScore(ans) {
    var totals = {};
    [1, 2, 3, 4].forEach(function (q) {
      var val = ans[q];
      if (!val) return;
      var pts = SCORES[val] || {};
      Object.keys(pts).forEach(function (k) {
        totals[k] = (totals[k] || 0) + pts[k];
      });
    });
    var winner = null, top = -1;
    Object.keys(totals).forEach(function (k) {
      if (totals[k] > top) { top = totals[k]; winner = k; }
    });
    // Fallback: si no hay puntos (todas las respuestas sin scoring), usar P1
    return winner || ans[1] || null;
  }

  function buildReasonText(ans, baseWhy) {
    var mentions = [];
    [1, 2, 3, 4].forEach(function (q) {
      var v = ans[q];
      if (v && MENTION[v]) mentions.push(MENTION[v]);
    });
    if (!mentions.length) return baseWhy;
    return baseWhy + ' Tu diagnóstico consideró: ' + mentions.join(', ') + '.';
  }

  /* ──────────────────────────────────────────────
     1) TEASER DE LA HOME — quiz inline 4 pasos
     ────────────────────────────────────────────── */
  function initTool(root) {
    if (!root || root.__cedToolInit) return;
    root.__cedToolInit = true;

    var TOTAL = 4;
    var panels = root.querySelectorAll('[data-ced-home-panel]');
    var previews = root.querySelectorAll('[data-ced-preview]');
    var secondaryCta = root.querySelector('[data-ced-secondary-cta]');
    var ctaBase = secondaryCta ? secondaryCta.getAttribute('href') : null;
    var homeAnswers = {};

    function showPanel(key) {
      var k = String(key);
      panels.forEach(function (p) {
        p.classList.toggle('is-hidden', p.getAttribute('data-ced-home-panel') !== k);
      });
    }

    function selectPreview(key) {
      previews.forEach(function (p) {
        p.classList.toggle('is-hidden', p.getAttribute('data-ced-preview') !== key);
      });
      if (secondaryCta && ctaBase) {
        secondaryCta.setAttribute('href', ctaBase + (ctaBase.indexOf('?') > -1 ? '&' : '?') + 'perfil=' + encodeURIComponent(key));
      }
    }

    function showResult() {
      var key = calcScore(homeAnswers);
      if (!key) {
        var firstPrev = previews[0];
        key = firstPrev ? firstPrev.getAttribute('data-ced-preview') : '';
      }
      selectPreview(key);
      var store = readStore(); store.problema = key; writeStore(store);
      showPanel('result');
    }

    // Selección de opción en cualquier panel
    root.querySelectorAll('[data-ced-home-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-ced-home-opt');
        var val = btn.getAttribute('data-ced-home-val');
        root.querySelectorAll('[data-ced-home-opt="' + q + '"]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        homeAnswers[parseInt(q, 10)] = val;
      });
    });

    // Continuar
    root.querySelectorAll('[data-ced-home-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = null;
        panels.forEach(function (p) {
          if (!p.classList.contains('is-hidden')) current = p.getAttribute('data-ced-home-panel');
        });
        var n = parseInt(current, 10);
        if (!homeAnswers[n]) return;
        if (n < TOTAL) showPanel(n + 1);
        else showResult();
      });
    });

    // Atrás
    root.querySelectorAll('[data-ced-home-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = null;
        panels.forEach(function (p) {
          if (!p.classList.contains('is-hidden')) current = p.getAttribute('data-ced-home-panel');
        });
        var n = parseInt(current, 10);
        if (n > 1) showPanel(n - 1);
      });
    });

    // Volver a empezar
    var redoBtn = root.querySelector('[data-ced-home-redo]');
    if (redoBtn) {
      redoBtn.addEventListener('click', function () {
        homeAnswers = {};
        root.querySelectorAll('[data-ced-home-opt]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        showPanel(1);
      });
    }

    // Estado inicial: restaurar selección guardada en P1
    var stored = readStore();
    if (stored.problema) {
      homeAnswers[1] = stored.problema;
      var storedBtn = root.querySelector('[data-ced-home-opt="1"][data-ced-home-val="' + stored.problema + '"]');
      if (storedBtn) {
        storedBtn.classList.add('is-active');
        storedBtn.setAttribute('aria-pressed', 'true');
      }
    }

    showPanel(1);
  }

  /* ──────────────────────────────────────────────
     2) QUIZ + RESULTADO
     ────────────────────────────────────────────── */
  function initQuiz(root) {
    if (!root || root.__cedQuizInit) return;
    root.__cedQuizInit = true;

    var quizEl = root.querySelector('[data-ced-quiz]');
    var resultEl = root.querySelector('[data-ced-result]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ced-step]'));
    var total = steps.length || 4;
    var progressBar = root.querySelector('[data-ced-progress-bar]');
    var progressLabel = root.querySelector('[data-ced-progress-label]');
    var nextBtn = root.querySelector('[data-ced-next]');
    var backBtn = root.querySelector('[data-ced-back]');
    var routines = {};
    try { routines = JSON.parse(root.querySelector('[data-ced-routines]').textContent) || {}; }
    catch (e) { routines = {}; }

    var current = 1;
    var answers = readStore().answers || {};
    var autoAdvTimer = null;

    function showStep(n) {
      current = n;
      steps.forEach(function (s) {
        s.classList.toggle('is-hidden', parseInt(s.getAttribute('data-ced-step'), 10) !== n);
      });
      if (progressBar) progressBar.style.width = Math.round((n / total) * 100) + '%';
      if (progressLabel) progressLabel.textContent = 'Pregunta ' + n + ' de ' + total;
      if (backBtn) backBtn.hidden = n === 1;
      if (nextBtn) {
        nextBtn.disabled = !answers[n];
        var nextLabel = nextBtn.querySelector('.ced-diag__next-label');
        if (nextLabel) nextLabel.textContent = (n === total ? 'Ver mi resultado' : 'Continuar');
      }
    }

    // Selección de opción (con auto-avance)
    root.querySelectorAll('[data-ced-answer]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var q = opt.getAttribute('data-ced-answer');
        var val = opt.getAttribute('data-ced-value');
        root.querySelectorAll('[data-ced-answer="' + q + '"]').forEach(function (o) {
          o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
        });
        answers[q] = val;
        var store = readStore(); store.answers = answers; writeStore(store);
        if (nextBtn) nextBtn.disabled = false;
        clearTimeout(autoAdvTimer);
        var qNum = parseInt(q, 10);
        autoAdvTimer = setTimeout(function () {
          if (qNum < total) showStep(qNum + 1);
          else finish();
        }, 500);
      });
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (!answers[current]) return;
      if (current < total) showStep(current + 1);
      else finish();
    });
    if (backBtn) backBtn.addEventListener('click', function () {
      if (current > 1) showStep(current - 1);
    });

    function finish() {
      var key = calcScore(answers);
      var data = routines[key];
      if (!data) {
        var keys = Object.keys(routines);
        key = keys[0]; data = routines[key];
      }
      renderResult(key, data, answers);
      if (quizEl) quizEl.classList.add('is-hidden');
      if (resultEl) resultEl.classList.remove('is-hidden');
      var store = readStore(); store.problema = key; writeStore(store);
      // Handoff para apps externas (Quizify/Octane/RevenueHunt o motor propio)
      document.dispatchEvent(new CustomEvent('ced:diag:result', {
        detail: { problema: key, answers: answers, routine: data }
      }));
      if (resultEl && resultEl.scrollIntoView) {
        try { resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }
    }

    function renderResult(key, data, answers) {
      if (!data) return;
      setText('[data-ced-r-profile]', data.profile);
      setText('[data-ced-r-why]', buildReasonText(answers || {}, data.why));
      setText('[data-ced-r-benefit]', data.benefit);

      // "Tu rutina incluye"
      var incl = root.querySelector('[data-ced-r-includes]');
      if (incl) {
        incl.innerHTML = '';
        (data.steps || []).forEach(function (s) {
          var li = document.createElement('li');
          li.innerHTML = checkIco() + s.type + ' <span>· ' + (s.fn || '') + '</span>';
          incl.appendChild(li);
        });
      }

      // Product cards
      var wrap = root.querySelector('[data-ced-r-cards]');
      if (wrap) {
        wrap.innerHTML = '';
        var variantIds = [];
        (data.steps || []).forEach(function (s, i) {
          if (s.variantId) variantIds.push(s.variantId);
          wrap.appendChild(buildCard(s, i + 1));
        });
        // Botón comprar: habilitar solo si los 3 pasos tienen variantId
        var buyBtn = root.querySelector('[data-ced-buy]');
        if (buyBtn) {
          var allReady = variantIds.length === (data.steps || []).length && variantIds.length > 0;
          buyBtn.disabled = !allReady;
          buyBtn.removeAttribute('title');
          if (allReady) {
            buyBtn.setAttribute('data-variant-ids', variantIds.join(','));
          } else {
            buyBtn.title = 'Productos pendientes de configurar';
          }
        }
        // Botón "Ver rutina ideal": apuntar a collectionUrl o esconder
        var collBtn = root.querySelector('[data-ced-buy-separate]');
        if (collBtn) {
          if (data.collectionUrl) {
            collBtn.setAttribute('href', data.collectionUrl);
            collBtn.textContent = 'Ver rutina ideal';
            collBtn.hidden = false;
          } else {
            collBtn.hidden = true;
          }
        }
      }
    }

    function esc(str) {
      return (str == null ? '' : String(str))
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function buildCard(step, n) {
      var el = document.createElement('div');
      var hasProduct = !!(step.variantId || step.pid);
      el.className = 'ced-card ced-card--lg ' + (hasProduct ? 'ced-card--real' : 'ced-card--ph');
      if (!hasProduct) el.setAttribute('data-ced-placeholder', '');

      var mediaInner = step.image
        ? '<img class="ced-card__img" src="' + esc(step.image) + '" alt="' + esc(step.title) + '" loading="lazy">'
        : '<div class="ced-card__media-empty"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.3"/><circle cx="8.5" cy="9.5" r="1.6" stroke="currentColor" stroke-width="1.3"/><path d="M21 16l-5-5L5 20" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';

      var nameHtml = step.title
        ? '<p class="ced-card__name">' + esc(step.title) + '</p>'
        : '<span class="ced-card__skel ced-card__skel--name"></span>';

      var hasSale = step.comparePrice && step.comparePrice !== step.price;
      var priceHtml = step.price
        ? (hasSale
            ? '<div class="ced-card__price-wrap">' +
                '<s class="ced-card__price-before">' + esc(step.comparePrice) + '</s>' +
                '<span class="ced-card__price ced-card__price--sale">' + esc(step.price) + '</span>' +
              '</div>'
            : '<span class="ced-card__price">' + esc(step.price) + '</span>')
        : '<span class="ced-card__skel ced-card__skel--price"></span>';

      var viewHtml = step.handle
        ? '<a class="ced-card__view" href="/products/' + esc(step.handle) + '">Ver producto ' + arrowIco() + '</a>'
        : '<span class="ced-card__view is-inert">Ver producto ' + arrowIco() + '</span>';

      el.innerHTML =
        '<div class="ced-card__media">' +
          mediaInner +
          '<span class="ced-card__step">Paso ' + n + '</span>' +
          '<span class="ced-card__rec">' + checkIco() + 'Recomendado</span>' +
        '</div>' +
        '<div class="ced-card__body">' +
          '<div class="ced-card__meta"><span class="ced-card__type">' + esc(step.type || 'Producto') + '</span>' +
            (step.fn ? '<span class="ced-card__fn">' + esc(step.fn) + '</span>' : '') + '</div>' +
          nameHtml +
          '<div class="ced-card__foot">' + priceHtml + viewHtml + '</div>' +
        '</div>';
      return el;
    }

    function setText(sel, txt) {
      var el = root.querySelector(sel);
      if (el) el.textContent = txt || '—';
    }
    function checkIco() { return '<svg class="ced-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
    function arrowIco() { return '<svg class="ced-ico" viewBox="0 0 20 12" fill="none" aria-hidden="true"><path d="M1 6h17M13 1l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }

    // Rehacer
    var redo = root.querySelector('[data-ced-redo]');
    if (redo) redo.addEventListener('click', function () {
      answers = {};
      var store = readStore(); delete store.answers; delete store.problema; writeStore(store);
      root.querySelectorAll('[aria-checked="true"]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      if (resultEl) resultEl.classList.add('is-hidden');
      if (quizEl) quizEl.classList.remove('is-hidden');
      showStep(1);
    });

    function showToast(count) {
      var existing = document.querySelector('.ced-toast');
      if (existing) existing.remove();
      var t = document.createElement('div');
      t.className = 'ced-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML =
        '<span class="ced-toast__ico" aria-hidden="true">✓</span>' +
        '<div class="ced-toast__body">' +
          '<strong>¡Rutina agregada!</strong>' +
          '<span>' + count + ' producto' + (count !== 1 ? 's' : '') + ' en tu carrito</span>' +
        '</div>' +
        '<a class="ced-toast__link" href="/cart">Ver carrito</a>' +
        '<button class="ced-toast__close" aria-label="Cerrar">&#x2715;</button>';
      document.body.appendChild(t);
      t.querySelector('.ced-toast__close').addEventListener('click', function () {
        t.classList.add('is-out');
        setTimeout(function () { t.remove(); }, 300);
      });
      var timer = setTimeout(function () {
        t.classList.add('is-out');
        setTimeout(function () { t.remove(); }, 300);
      }, 5000);
      t.querySelector('.ced-toast__link').addEventListener('click', function () {
        clearTimeout(timer); t.remove();
      });
    }

    function addToCart(variantIds, btn) {
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Agregando...';
      var items = variantIds.map(function (id) { return { id: id, quantity: 1 }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        btn.textContent = '¡Agregado al carrito!';
        btn.classList.add('ced-diag__btn--success');
        document.dispatchEvent(new CustomEvent('ced:diag:buy', { detail: { ids: variantIds } }));
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var countText = cart.item_count < 100 ? String(cart.item_count) : '99';
        var badge = document.querySelector('#cart-icon-bubble .ced-cart-badge');
        if (badge) {
          badge.textContent = countText;
        } else if (cart.item_count > 0) {
          var cartLink = document.querySelector('#cart-icon-bubble');
          if (cartLink) {
            var nb = document.createElement('span');
            nb.className = 'ced-cart-badge';
            nb.setAttribute('data-cart-count', '');
            nb.textContent = countText;
            cartLink.appendChild(nb);
          }
        }
        // Notificar al sistema de Dawn para que re-renderice el carrito si está abierto
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ced-diagnostico', cartData: cart });
        }
        // Toast de confirmación siempre visible
        showToast(variantIds.length);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.innerHTML = label;
        btn.title = err.message || 'Error al agregar. Intenta de nuevo.';
      });
    }

    var buyBtn = root.querySelector('[data-ced-buy]');
    if (buyBtn) buyBtn.addEventListener('click', function () {
      if (buyBtn.disabled) return;
      var ids = (buyBtn.getAttribute('data-variant-ids') || '')
        .split(',').map(Number).filter(Boolean);
      if (!ids.length) return;
      addToCart(ids, buyBtn);
    });

    // Deep-link: si llega ?perfil= pre-selecciona P1 sin auto-avanzar
    var deep = getParam('perfil');
    if (deep) {
      var preOpt = root.querySelector('[data-ced-answer="1"][data-ced-value="' + deep + '"]');
      if (preOpt) {
        root.querySelectorAll('[data-ced-answer="1"]').forEach(function (o) {
          o.setAttribute('aria-checked', o === preOpt ? 'true' : 'false');
        });
        answers['1'] = deep;
        var s = readStore(); s.answers = answers; writeStore(s);
        if (nextBtn) nextBtn.disabled = false;
      }
    }

    // Restaurar resultado si el quiz fue completado en esta sesión (persiste en refresh)
    var stored = readStore();
    if (stored.problema && stored.answers && Object.keys(stored.answers).length >= 4) {
      answers = stored.answers;
      finish();
    } else {
      showStep(1);
    }
  }

  /* ──────────────────────────────────────────────
     3) Bootstrap + soporte Theme Editor
     ────────────────────────────────────────────── */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-ced-tool]').forEach(initTool);
    (scope || document).querySelectorAll('[data-ced-quiz-root]').forEach(initQuiz);
  }
  window.CED.boot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }

  // Theme Editor: re-inicializa al cargar/recargar una sección
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t) { t.querySelectorAll && boot(t); initTool(t.querySelector && t.querySelector('[data-ced-tool]')); }
  });
})();
